import { CommonModule } from '@angular/common';
import { Component, input, OnDestroy, OnInit, output } from '@angular/core';
import { Types } from 'shared-lib';
import { EComponentSize, EIcon } from '../../types';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'ui-image-viewer',
    standalone: true,
    imports: [CommonModule, IconComponent],
    templateUrl: './image-viewer.component.html',
    styleUrls: ['./image-viewer.component.scss']
})
export class ImageViewerComponent implements OnInit, OnDestroy {
    imageUrl = input<string>('/images/user_image.png');
    close = output<void>();

    EAlert = Types.EAlert;
    EIcon = EIcon;
    EComponentSize = EComponentSize;

    closePopup() {
        this.close.emit();
    }

    ngOnInit() {
        document.addEventListener('keydown', this.listenForEsc());
      }
    
      ngOnDestroy() {
        document.removeEventListener('keydown', this.listenForEsc());
      }
    
      listenForEsc() {
        return (event: KeyboardEvent) => {
          if (event.key === 'Escape') {
            this.closePopup();
          }
        };
      }
    
}
